import { PbxHttpClient } from "@/services/httpclient";

const state = {
    allProcess: []
};

const getters = {
    GET_ALL_PROCESS: state => state.allProcess
};

const mutations = {
    SET_ALL_PROCESS: (state, payload) => state.allProcess = payload,

    PUSH_PROCESS: (state, payload) => state.allProcess.push({...payload, id: (state.allProcess.length + 1)}),
    
    UPDATE_PROCESS: (state, payload) => {
        const index = state.allProcess.findIndex(el => el.id === payload.id);
        state.allProcess.splice(index, 1, payload);
    },

    DELETE_PROCESS: (state, id) => {
        const index = state.allProcess.findIndex(el => el.id === id);
        state.allProcess.splice(index, 1);
    }
};

const actions = {
    async REGISTER_PROCESS({commit, dispatch}, payload) {
        try {
             await PbxHttpClient.post(`/quality/process`, payload);
             dispatch("SHOW_PROCESS", payload.evaluation_id)
            //FOR TESTING
            // console.log(response.data)
            // commit("PUSH_PROCESS", response.data.process);
            return;
        } catch (error) {
            return error.message.includes("422") ? 422 : error
        }
    },

    async SHOW_PROCESS({ commit }, payload) {
        try {
            const response = await PbxHttpClient.get(`/quality/process/index/${payload}`);
            // console.log(response)
            // FOR TESTING
            // console.log(response.data.data)
            commit("SET_ALL_PROCESS", response.data.data[0].process);
            return response.data.data[0].process;
        } catch (error) {
            return error.message.includes("422") ? 422 : error
        }
    },
    async EDIT_PROCESS({ commit }, {id,...payload}) {
        try {
            const response = await PbxHttpClient.put(`/quality/process/${id}`, payload);
            // console.log(response.data)
            commit("UPDATE_PROCESS", 
            response.data.process
            );
        } catch (error) {
            return error.message.includes("422") ? 422 : error
        }
    },

    async DELETE_PROCESS({ commit }, id) {
        try {
             const res =  await PbxHttpClient.delete(`/quality/process/${id}`);
            commit("DELETE_PROCESS", id);
            return;
        } catch (error) {
            return Promise.reject(error);
        }
    }
};

// Exportar Clientes
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
